import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      window.scrollTo({
        top: section.offsetTop - 70, // 減去header高度的偏移
        behavior: 'smooth'
      });
      setMobileMenuOpen(false); // 點擊後關閉移動端菜單
    }
  };

  const handleNavigation = (sectionId, event) => {
    event.preventDefault();
    
    // 如果已经在主页，直接滚动
    if (isHomePage) {
      scrollToSection(sectionId);
    } else {
      // 如果不在主页，导航到主页并传递要滚动的区域ID
      navigate('/', { state: { scrollTo: sectionId } });
    }
  };

  useEffect(() => {
    // 監聽滾動事件改變header樣式
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // 處理從其他頁面導航到特定section的邏輯
    if (location.state && location.state.scrollTo) {
      const sectionId = location.state.scrollTo;
      const element = document.getElementById(sectionId);
      if (element) {
        // 等待頁面渲染完成後滾動
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }

    // 根据当前页面设置不同的标题和描述
    if (isHomePage) {
      // 主页的元信息
      document.title = "AI Meeting Pro | The Smartest Way to Prepare for Interviews";
      
      // 創建或更新meta描述標籤
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.name = "description";
        document.head.appendChild(metaDescription);
      }
      metaDescription.content = "Boost your interview success rate with AI Meeting Pro. Practice, analyze, and improve your skills with personalized feedback.";
      
      // 創建或更新關鍵字meta標籤
      let metaKeywords = document.querySelector('meta[name="keywords"]');
      if (!metaKeywords) {
        metaKeywords = document.createElement('meta');
        metaKeywords.name = "keywords";
        document.head.appendChild(metaKeywords);
      }
      metaKeywords.content = "interview preparation, AI interview assistant, job interview, interview practice, interview coaching, AI Meeting Pro";
      
      // 添加Open Graph標籤用於社交媒體分享
      let ogTitle = document.querySelector('meta[property="og:title"]');
      if (!ogTitle) {
        ogTitle = document.createElement('meta');
        ogTitle.setAttribute('property', 'og:title');
        document.head.appendChild(ogTitle);
      }
      ogTitle.content = "AI Meeting Pro | Ace Your Next Interview";
      
      let ogDescription = document.querySelector('meta[property="og:description"]');
      if (!ogDescription) {
        ogDescription = document.createElement('meta');
        ogDescription.setAttribute('property', 'og:description');
        document.head.appendChild(ogDescription);
      }
      ogDescription.content = "Practice interviews with AI feedback. Join 10,000+ professionals who landed their dream jobs.";
      
      let ogType = document.querySelector('meta[property="og:type"]');
      if (!ogType) {
        ogType = document.createElement('meta');
        ogType.setAttribute('property', 'og:type');
        document.head.appendChild(ogType);
      }
      ogType.content = "website";
      
      // 添加Twitter Card標籤
      let twitterCard = document.querySelector('meta[name="twitter:card"]');
      if (!twitterCard) {
        twitterCard = document.createElement('meta');
        twitterCard.name = "twitter:card";
        document.head.appendChild(twitterCard);
      }
      twitterCard.content = "summary_large_image";
    } else if (location.pathname === '/download') {
      // 下载页的元信息
      document.title = "下載 AI Meeting Pro | 桌面應用程式";
      
      // 更新meta描述標籤
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.name = "description";
        document.head.appendChild(metaDescription);
      }
      metaDescription.content = "下載 AI Meeting Pro 桌面應用程式，適用於 Windows、macOS 或 Linux。離線練習面試並提高您的技能。";
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [location, isHomePage]);

  return (
    <header className={`site-header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo">
          <a href="/">AI Meeting Pro</a>
        </div>
        
        <div className={`mobile-menu-icon ${mobileMenuOpen ? 'active' : ''}`} onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        
        <nav className={`main-nav ${mobileMenuOpen ? 'open' : ''}`}>
          <ul>
            <li>
              <a href="/" onClick={isHomePage ? (e) => { e.preventDefault(); scrollToSection('hero'); } : undefined}>
                Home
              </a>
            </li>
            <li>
              <a href="/" onClick={(e) => handleNavigation('features', e)}>
                Features
              </a>
            </li>
            <li>
              <a href="/" onClick={(e) => handleNavigation('faq', e)}>
                FAQ
              </a>
            </li>
            <li>
              <a href="/p" className={location.pathname === '/p' ? 'active' : ''}>
                Blog
              </a>
            </li>
            <li>
              <a href="/" onClick={(e) => handleNavigation('pricing', e)} className="nav-cta">
                Pricing
              </a>
            </li>
            <li>
              <a href="/download" className={location.pathname === '/download' ? 'active' : ''}>
                Download
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;